module.exports = __webpack_public_path__ + "static/media/health.aa2cf6a3.svg";